import styled from "styled-components";

const FreteGratisMainContainer = styled.div`
  position: relative;
  width: 100%;
  .dropdown {
    .novo {
      cursor: pointer;
      margin-top: 0;
      text-align: left;
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

export { FreteGratisMainContainer };
